import React, { Component } from 'react';
import config from '../../config';
import  './header.css';

class Header extends Component {
    render() {

       let title,title_tooltip;
        if(config.data.title !== undefined)
        {
                title = config.data.title.length >=70 ? config.data.title.substring(0,70)+" ..." : config.data.title,
                title_tooltip = config.data.title.length>=70 ? config.data.title : ''
        }

        return (
            <div class="row breadcrumb text-center">
                <div class="col-md-12">
                    <a href="/">
                        <span class="hae">Home</span>
                    </a>
                    <i class="fa fa-angle-right"></i>
                    <a href="/industry-reports">
                        <span class="hae">Industry Reports</span>
                    </a>
                    <i class="fa fa-angle-right"></i>
                    <a href={"/industry-reports/category/"+config.data.category.slug}>
                        <span class="hae">{config.data.category.title} </span>
                    </a>
                    <i class="fa fa-angle-right"></i>
                    <a href={"/industry-reports/category/"+config.data.category.slug+"/"+config.data.sub_category.slug}>
                        <span class="hae">{config.data.sub_category.title} </span>
                    </a>
                    <i class="fa fa-angle-right"></i>
                    <a href={"/industry-reports/"+config.data.slug} title={title_tooltip}>
                        <span class="last">{title}</span>
                    </a>
                </div>
            </div>
        );
    }


}


export default Header;


// WEBPACK FOOTER //
// ./src/report-description/header/header.js